<template>
  <div class="warp">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return{
      version:window.sessionStorage.getItem('version')
    }
  },
  created(){
   console.log(this.version,'获取版本')
  },
  methods: {
      
      crateTest(){
        this.$ajax.post(this.G_uri+'/chooseSubject/startTest',{
          testType:1
        },
            {
              headers:{
                token: sessionStorage.getItem('token')
              }
            }).then(res=>{
          let data=res.data;
          if(data.code==2000){
            
            // code: 1.第一次测试2.继续测试3.测试完成4.绑卡
            if(data.data.code==1||data.data.code==2){
              sessionStorage.setItem('testId',data.data.testId)
              this.goonTest()
            }
            if(data.data.code==3){
              this.$router.push('/cepingwancheng');
            }
          }
        })
      },
        crateTest2(){
        this.$ajax.post(this.G_capi+'/test/create',{
          testType:1
        },
            {
              headers:{
                token: sessionStorage.getItem('token')
              }
            }).then(res=>{
          let data=res.data;
          if(data.code==2000){
            
            // code: 1.第一次测试2.继续测试3.测试完成4.绑卡
            if(data.data.code==1||data.data.code==2){
              sessionStorage.setItem('testId',data.data.testId)
              this.goonTest2()
            }
            if(data.data.code==3){
              this.$router.push('/cepingwancheng');
            }
          }
        })
      },
      goonTest(){
        this.$ajax.post(this.G_uris+'/usercenter/test/goon',{
           test_id: sessionStorage.getItem('testId')
        }, {
          headers:{
            token: sessionStorage.getItem('token')
          }
        }).then(res=>{
          if(res.data.code==2000){
            let data=res.data.data;
            if(data.module==1){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'0'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'rgtx',part:'rgtx'+data.node}})
              }
            }
            if(data.module==2){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'1'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'znsp',part:'znsp'+data.node}})
              }
            }
            if(data.module==3){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'2'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'xqqx',part:'xqqx'+data.node}})
              }
            }
            if(data.module==4){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'3'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'zyjzg',part:'zyjzg'+data.node}})
              }
            }
            if(data.module==5){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'4'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'xlssx',part:'xlssx'+data.node}})
              }
            }
          }
        })
      },
      goonTest2(){
        this.$ajax.post(this.G_capi+'/test/goon',{
           testId: sessionStorage.getItem('testId')
        }, {
          headers:{
            token: sessionStorage.getItem('token')
          }
        }).then(res=>{
          if(res.data.code==2000){
            let data=res.data.data;
            if(data.module==1){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'0'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'rgtx',part:'rgtx'+data.node}})
              }
            }
            if(data.module==2){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'1'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'znsp',part:'znsp'+data.node}})
              }
            }
            if(data.module==3){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'2'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'xqqx',part:'xqqx'+data.node}})
              }
            }
            if(data.module==4){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'3'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'zyjzg',part:'zyjzg'+data.node}})
              }
            }
            if(data.module==5){
              if(data.node == 11){
                this.$router.push({path:'/careerevalution/navigation',query:{part:'4'}})
              }else{
                this.$router.push({path:'/careerevalution/home',query: { name:'xlssx',part:'xlssx'+data.node}})
              }
            }
          }
        })
      },
      changeView(){
        $('body').css('overflow-x','auto')
        $('html').css('cssText','background:#fff!important')
        let width=$(document).width();
        let height=$(document).height();
          $('.warp').css({height:height+'px'})
        window.addEventListener('resize',function () {
          let width=$(document).width();
          let height=$(document).height();
          $('.warp').css({height:height+'px'})
        })
      }
    },
    mounted() {
    // this.$router.push({path:'/careerevalution/navigation',query:{part:'1'}})
       if(this.version == '/shengyaceping'){
      this.crateTest()
    }else{
      this.crateTest2()
    }
    //    this.crateTest()
        this.changeView()
    }
}
</script>

<style scoped>
  body{
    box-sizing: border-box;
  }
  .warp{
    background: url('/imgs/careerEvaluation/index_bg.png') no-repeat;
    background-size: 100% 100%;
    background-size: cover;
  }
</style>